import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Main tabs for bottom navigation (4 main + More)
const mainTabs = [
  { name: 'Home', href: '/', icon: '🏠' },
  { name: 'Tokens', href: '/tokens', icon: '📋' },
  { name: 'Recovery', href: '/recovery', icon: '📈' },
  { name: 'Milestones', href: '/milestones', icon: '🎯' },
];

// Additional items under "More" menu
const moreItems = [
  { name: 'Alerts', href: '/alerts', icon: '🔔' },
  { name: 'Wallet Monitor', href: '/wallet-monitor', icon: '👛' },
  { name: 'Frontrun', href: '/frontrun', icon: '⚡' },
  { name: 'Pings', href: '/pings', icon: '📡' },
  { name: 'Master Chef', href: '/trading/masterchef', icon: '🍳' },
  { name: 'Positions', href: '/trading/masterchef/positions', icon: '📋' },
  { name: 'Staged Recovering', href: '/trading/masterchef/staged', icon: '🍲' },
  { name: 'Activity', href: '/trading/masterchef/activity', icon: '📜' },
  { name: 'EMA Watchlist', href: '/trading/masterchef/ema', icon: '📉' },
  { name: 'Settings', href: '/trading/masterchef/settings', icon: '🔧' },
  { name: 'Chef Dataset', href: '/datasets/masterchef', icon: '🧪' },
  { name: 'Entry Logs', href: '/datasets/entry-logs', icon: '📝' },
  { name: 'Users', href: '/users', icon: '👥' },
  { name: 'Groups', href: '/groups', icon: '👨‍👩‍👧‍👦' },
  { name: 'Subscriptions', href: '/subscriptions', icon: '⭐' },
  { name: 'Transactions', href: '/transactions', icon: '📝' },
  { name: 'Settings', href: '/settings', icon: '⚙️' },
  { name: 'API', href: '/system/api', icon: '🔌' },
];

export default function BottomNav() {
  const location = useLocation();
  const { user, logout } = useAuth();
  const [showMore, setShowMore] = useState(false);

  const isActive = (href) => {
    if (href === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(href);
  };

  const isMoreActive = moreItems.some(item => isActive(item.href));

  return (
    <>
      {/* More Menu Overlay */}
      {showMore && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setShowMore(false)}
        />
      )}

      {/* More Menu Panel */}
      {showMore && (
        <div className="fixed bottom-16 left-0 right-0 bg-gray-900 z-50 rounded-t-2xl shadow-2xl max-h-[70vh] overflow-y-auto">
          <div className="p-4">
            <div className="flex items-center justify-between mb-4 pb-3 border-b border-gray-700">
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold">
                  {user?.username?.[0]?.toUpperCase()}
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-white">{user?.username}</p>
                  <p className="text-xs text-gray-400 dark:text-gray-500">{user?.role}</p>
                </div>
              </div>
              <button
                onClick={logout}
                className="px-3 py-1.5 text-sm text-white bg-red-600 rounded-lg hover:bg-red-700"
              >
                Logout
              </button>
            </div>

            <div className="grid grid-cols-4 gap-3">
              {moreItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setShowMore(false)}
                  className={`flex flex-col items-center p-3 rounded-xl transition-colors ${
                    isActive(item.href)
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                  }`}
                >
                  <span className="text-2xl mb-1">{item.icon}</span>
                  <span className="text-xs text-center">{item.name}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Bottom Navigation Bar */}
      <nav className="fixed bottom-0 left-0 right-0 bg-gray-900 border-t border-gray-800 z-50 safe-area-bottom">
        <div className="flex items-center justify-around h-16">
          {mainTabs.map((tab) => (
            <Link
              key={tab.name}
              to={tab.href}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                isActive(tab.href)
                  ? 'text-blue-500'
                  : 'text-gray-400 hover:text-gray-200'
              }`}
            >
              <span className="text-xl mb-0.5">{tab.icon}</span>
              <span className="text-xs">{tab.name}</span>
            </Link>
          ))}

          {/* More Button */}
          <button
            onClick={() => setShowMore(!showMore)}
            className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
              showMore || isMoreActive
                ? 'text-blue-500'
                : 'text-gray-400 hover:text-gray-200'
            }`}
          >
            <span className="text-xl mb-0.5">☰</span>
            <span className="text-xs">More</span>
          </button>
        </div>
      </nav>
    </>
  );
}
